module.exports = __webpack_public_path__ + "static/media/main idea.28244c34.mp3";